<template>
  <div
    class="sc-message-list"
    ref="scrollList"
    :style="{backgroundColor: colors.messageList.bg}"
    @scroll.passive="scrolled"
  >
    <message
      v-for="message in chat.messages"
      :key="message.mid"
      :message="message"
    >
      <template v-slot:user-avatar="scopedProps">
        <slot name="user-avatar" :user="scopedProps.user" :message="scopedProps.message"></slot>
      </template>
    </message>
    <typing-message
      v-if="chat.watermarks"
    />
  </div>
</template>
<script>
import Message from "./Message.vue";
import TypingMessage from "./messages/TypingMessage"

export default {
  name: "Messages",
  inject: {
    chat: {
      type: Object
    },
    widget: {
      type: Object
    },
    colors: {
      type: Object
    }
  },
  components: {
    Message,
    TypingMessage
  },
  data() {
    return {
      timeout: 0
    };
  },
  methods: {
    scrolled(e) {
      // Throttled
      clearTimeout(this.timeout);
      const scrollPercent = Math.round(
        (100 * e.target.scrollTop) / (e.target.scrollHeight || 1)
      );
      if (!this.widget.scroll && scrollPercent) {
        this.$nextTick(() => (this.widget.scroll = scrollPercent));
      } else if (scrollPercent) {
        this.timeout = setTimeout(() => {
          this.widget.scroll = scrollPercent;
        }, 400);
      } else if (this.widget.scroll) {
        this.$nextTick(() => (this.widget.scroll = scrollPercent));
      }
    },
    scrollTo(scroll) {
      // Debounced
      const scrollPercent = Math.round(
        (100 * this.$refs.scrollList.scrollTop) /
          (this.$refs.scrollList.scrollHeight || 1)
      );
      (Math.abs(scrollPercent - scroll) > 1 || scroll === 100) &&
        requestAnimationFrame(() => {
          this.$refs.scrollList.scrollTop = Math.round(
            (scroll * this.$refs.scrollList.scrollHeight) / 100
          );
        });
    }
  },
  watch: {
    "widget.scroll"(scroll) {
      if (scroll > 100) {
        return this.widget.scroll = 100
      }
      if (scroll < 0) {
        return this.widget.scroll = 0
      }
      this.widget.isOpen && this.scrollTo(scroll)
    },
    "widget.isOpen"(isOpen) {
      isOpen && this.scrollTo(this.widget.scroll)
    }
  }
};
</script>

<style scoped>
.sc-message-list {
  height: 80%;
  overflow-y: auto;
  background-size: 100%;
  padding: 40px 0px;
}
</style>
